import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { try_add_images_ids_to_special_collections } from '../_methods/try_add_images_ids_to_special_collections';
import { STATE__collections } from '../STATE__collections';

export const LOCAL__collection_cells_upsert = (payload: DTO__grid2d_cell[]): PayloadAction<DTO__grid2d_cell[]> => ({
  type: ENUM__redux_action.COLLECTION_CELLS_UPSERT,
  payload,
});

export function INIT_LOCAL__collection_cells_upsert(state: STATE__collections, action: PayloadAction<DTO__grid2d_cell[]>) {
  let items = action.payload;

  if (items.is_empty()) return;

  for (let item of items) {
    item = item.clone();

    try_add_images_ids_to_special_collections(state, item.workspace_id, item.grid2d_type, [item.hash_sha256_content]);
  }
}
